import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import InnovationIllustration from 'svg/illustrations/Innovation';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

const features = [
  {
    title: '1. Registro inteligente de egresos',
    items: [
      'Ingreso manual simple',
      'Registro mediante lenguaje natural (chat)',
      'Clasificación automática por categorías',
    ],
  },
  {
    title: '2. Gestión de datos centralizada',
    items: [
      'Base de datos estructurada',
      'Historial completo de egresos',
      'Conversión automática de bolívares a USD (según tasa BCV)',
    ],
  },
  {
    title: '3. Dashboard principal',
    items: [
      'Total de gastos (diario, semanal, mensual)',
      'Distribución por categorías',
      'Evolución de gastos en el tiempo',
      'Costo operativo mensual en USD',
    ],
  },
  {
    title: '4. Control de deuda básica',
    items: [
      'Registro de deudas (ej: proveedores de leche)',
      'Seguimiento de pagos realizados',
      'Balance pendiente',
    ],
  },
  {
    title: '5. Reportes automatizados',
    items: [
      'Resumen mensual de gastos',
      'Insights básicos (categorías con mayor impacto)',
    ],
  },
];

const AlcanceMVPSection = () => {
  const theme = useTheme();

  return (
    <Box>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        gutterBottom
        color="primary"
        align="center"
      >
        Alcance del MVP (Fase 1)
      </Typography>
      <Typography variant="h5" fontWeight={700} align="center" gutterBottom>
        El sistema se enfocará exclusivamente en el control de gastos
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        sx={{ maxWidth: 720, mx: 'auto', mb: 4 }}
      >
        Tomando como base la estructura actual en Excel
      </Typography>
      <Grid container spacing={3}>
        {features.map((feature, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Box
              component={Card}
              variant="outlined"
              sx={{
                borderLeft: 4,
                borderColor: theme.palette.primary.main,
                height: '100%',
              }}
            >
              <CardContent>
                <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
                  {feature.title}
                </Typography>
                <List dense disablePadding>
                  {feature.items.map((item, j) => (
                    <ListItem key={j} disableGutters alignItems="flex-start">
                      <ListItemIcon sx={{ minWidth: 28 }}>
                        <Box
                          sx={{
                            width: 6,
                            height: 6,
                            borderRadius: '50%',
                            bgcolor: theme.palette.primary.main,
                            mt: 1.25,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={item}
                        primaryTypographyProps={{ variant: 'body2' }}
                      />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box mt={6} display="flex" justifyContent="center" alignItems="center">
        <Box maxWidth={320} width="100%">
          <InnovationIllustration height="100%" width="100%" />
        </Box>
      </Box>
    </Box>
  );
};

export default AlcanceMVPSection;
